var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-image",style:(_vm.modalStyle),attrs:{"id":"myModal","scroll":"no"}},[_c('span',{staticClass:"modal-image__close",on:{"click":function($event){return _vm.close()}}},[_c('img',{attrs:{"src":_vm.imagesUrl + 'close-btn.svg',"alt":"popup"}})]),_c('img',{staticClass:"modal-image__content",attrs:{"src":_vm.image}})])
}
var staticRenderFns = []

export { render, staticRenderFns }